var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"im-checkbox",class:[{checked: _vm.isChecked}],on:{"click":function($event){return _vm.toggle()}}},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-checkbox"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }